import React from 'react';
import { View, Text } from 'react-native';
import { withRouter } from "react-router-dom";
import {Button, CardTextArrow, Spacing} from "../../components";
import {formatDate} from "../../constants/formatDate";

const JourneyDeliveryComponent = (props) => {

    const { title, description, createdAt, GSI1PK } = props.data;

    return (
        <CardTextArrow
            text={title}
            showArrow={false}
            onPress={() => console.log('move to avaliation screen!')}
        >
            {/*<Spacing height={6} />*/}
            {/*<Text style={{ fontSize: 16, color: 'white' }}>*/}
            {/*    { description }*/}
            {/*</Text>*/}
            <Spacing height={10} />

            <Text style={{ fontSize: 14, color: 'white' }}>
                { `Enviado em ${formatDate(createdAt)}` }
                {/*{ `Enviado por ${GSI1PK} em ${formatDate(createdAt)}` }*/}
            </Text>
            <Spacing height={10} />
            <Button
                text={'Avaliar'}
                onPress={() => props.history.push('/applications/review', { deliveryData: props.data } )}
                // onPress={() => props.navigation.navigate('DeliveryReview', { deliveryData: props.data } )}
                containerPropsStyle={{ height: 30, borderRadius: 8 }}
                textPropsStyle={{ fontSize: 16 }}
            />

        </CardTextArrow>
    )
}

export default withRouter(JourneyDeliveryComponent);
